import { constructEnum } from '@/lib/enum';

export default constructEnum('ExternalPlatformType', {
  TWENTY_NINE_CM: 20,
  MUSINSA: 40,
  OHOUSE: 50,
  AUCTION: 60,
  OLIVE_YOUNG: 70,
  WADIZ: 80,
  COUPANG: 90,
  GSSHOP: 110,
  WCONCEPT: 120,
  NAVER_PLACE: 130,
  QUEENIT: 140
});
